/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    'use strict';

    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    interface ILabels {
        tips: string[],
        main: string,
        allSelected: string,
        error: string
    }

    interface IListMoverModel {
        selected: boolean;
        id?: string;
        displayName?: string;
    }

    export interface IListMoverController {
        // comes from directive's scope
        centralOffice: boolean;
        securityAccess: SecurityAccessEnum;
        disabled: boolean;
        template: string;
        criteria: Object;
        watchCriteria: boolean;
        useAllItemsAsSelected: boolean;
        defaultValue: IListMoverModel[];
        fetchOnStart: boolean;
        fullResponse: boolean;
        generic: boolean;
        genericUrl: string;
        genericArrayList: Array<any>;
        identifier?: string;
        displayName?: string;
        postLoad?: Function;
        isSelectAllCheckboxHidden: boolean;
        allSelected: boolean;
        hideTopOnCollapse: boolean;
        advancedSearch: Object;
        nullIfEmpty: boolean;
        setIdOnCriteriaChanged: boolean;
        required: boolean;
        useSelectCaptions: boolean;
        isSystemUserSelected?: boolean;
        reportShortCut?: string;
        allSelectedToggleCallback?: (newValue: boolean) => void;

        // comes from directive's link function
        ngModel: angular.INgModelController;

        // props used in templates
        labels: ILabels;
        fetching: boolean;
        error: string;
        securityDisabled: boolean;

        // lists used in template
        available: IListMoverModel[];
        selected: IListMoverModel[];
        availableSelection: Array<string | number>;
        selectedSelection: Array<string | number>;

        init(): void;
        fetchList(selectAllItems?: boolean): void;
        populate(list: any[]): void;
        setWatchers(): void;
        updateLists(): void;
        select(): void;
        deselect(): void;
        moveAll(selected: boolean): void;
        getList(selected: boolean): IListMoverModel[];
        resetModelViewValue(): void;
        checkAllCallback(): void;
        isAdding: boolean;
    }

    const LABELS = {
        'ReportCategories': {
            main: 'LABEL_REPORT_TYPE',
            allSelected: 'LABEL_ALL_REPORT_TYPES',
            tips: []
        },
        'AlertConfigReport': {
            main: 'HERO_REPORTS',
            allSelected: 'LABEL_ALL_REPORTS',
            tips: []
        },
        'EmployeeCategory': {
            main: 'LABEL_EMPLOYEE_CATEGORIES',
            allSelected: 'LABEL_ALL_EMPLOYEE_CATEGORIES',
            tips: []
        },
        'ReferralType': {
            main: 'LABEL_REFERRAL_TYPE',
            allSelected: 'LABEL_ALL_REFERRAL_TYPES',
            tips: ['TIP_NOT_SELECTING_REFERRAL_TYPE']
        },
        'ProductCategory': {
            main: 'LABEL_PRODUCT_CATEGORY',
            allSelected: 'LABEL_ALL_PRODUCT_CATEGORIES',
            tips: []
        },
        'productcategories': {
            main: 'LABEL_PRODUCT_CATEGORY',
            allSelected: 'LABEL_ALL_PRODUCT_CATEGORIES',
            tips: ['TIP_NOT_SELECTING_PRODUCT_CATEGORY']
        },
        'ServiceCategory': {
            main: 'LABEL_SERVICE_CATEGORY',
            allSelected: 'LABEL_ALL_SERVICE_CATEGORIES',
            tips: ['TIP_NOT_SELECTING_SERVICE_CATEGORY']
        },
        'serviceCategory': {
            main: 'LABEL_SERVICE_CATEGORY',
            allSelected: 'LABEL_ALL_SERVICE_CATEGORIES',
            tips: ['TIP_NOT_SELECTING_SERVICE_CATEGORY']
        },
        'Drawer': {
            main: 'LABEL_DRAWER',
            allSelected: 'LABEL_ALL_DRAWERS',
            tips: ['TIP_NOT_SELECTING_DRAWER']
        },
        'Role': {
            main: 'LABEL_SECURITY_ROLES',
            allSelected: 'LABEL_ALL_SECURITY_ROLES',
            tips: []
        },
        'MenuItem': {
            main: 'LABEL_MEEVO_MENU_ITEMS',
            allSelected: 'LABEL_ALL_MEEVO_MENU_ITEMS',
            tips: []
        },
        'PaymentType': {
            main: 'LABEL_PAYMENT_TYPE',
            allSelected: 'LABEL_ALL_PAYMENT_TYPES',
            tips: [
                'TIP_NOT_SELECTING_PAYMENT_TYPE',
                'NOTE_PAYMENT_TYPES'
            ]
        },
        'product': {
            main: 'HEADER_PRODUCTS',
            allSelected: 'LABEL_ALL_PRODUCTS',
            tips: []
        },
        'employee': {
            main: 'LABEL_EMPLOYEE',
            allSelected: 'LABEL_ALL_EMPLOYEES',
            tips: []
        },
        'Service': {
            main: 'SERVICES',
            allSelected: 'LABEL_ALL_SERVICES',
            tips: []
        },
        'ReportServices': {
            main: 'SERVICES',
            allSelected: 'LABEL_ALL_SERVICES',
            tips: []
        },
        'EmployeeClassification': {
            main: 'LABEL_EMPLOYEE_CATEGORIES',
            allSelected: 'LABEL_ALL_EMPLOYEE_CATEGORIES',
            tips: []
        },
        'Employee': {
            main: 'LABEL_EMPLOYEE',
            allSelected: 'LABEL_ALL_EMPLOYEES',
            tips: []
        },
        'User': {
            main: 'LABEL_USER',
            allSelected: 'LABEL_ALL_CREATED_BY_USERS',
            tips: []
        },
        'PurchaseOrder': {
            main: 'HERO_SUB_PURCHASE_ORDER',
            allSelected: 'LABEL_ALL_PURCHASE_ORDERS',
            tips: []
        },
        'Distributor': {
            main: 'LABEL_DISTRIBUTOR',
            allSelected: 'LABEL_ALL_DISTRIBUTORS',
            tips: []
        },
        'Manufacturer': {
            main: 'LABEL_MANUFACTURERS',
            allSelected: 'LABEL_ALL_MANUFACTURERS',
            tips: []
        },
        'Liability': {
            main: 'LABEL_LIABILITIES',
            allSelected: 'LABEL_ALL_LIABILITIES',
            tips: []
        },
        'InventoryReturn': {
            main: 'HERO_SUB_INVENTORY_RETURNS',
            allSelected: 'LABEL_REPORT_INVENTORY_RETURN_ALL_RETURNS',
            tips: []
        },
        'FloorLocation': {
            main: 'LABEL_FLOOR_LOCATION',
            allSelected: 'LABEL_ALL_FLOOR_LOCATION',
            tips: []
        },
        'Memberships': {
            main: 'LABEL_MEMBERSHIPS',
            allSelected: 'LABEL_ALL_MEMBERSHIPS',
            tips: []
        },
        'GiftCardType': {
            main: 'LABEL_GIFT_CARD_TYPE',
            allSelected: 'LABEL_ALL_GIFT_CARD_TYPE',
            tips: []
        },
        'DP005Product': {
            main: 'HEADER_PRODUCTS',
            allSelected: 'LABEL_ALL_PRODUCTS',
            tips: []
        },
        'promotionCampaign': {
            main: 'LABEL_POINT_PROMOTIONS',
            allSelected: 'LABEL_ALL_POINT_PROMOTIONS',
            tips: []
        },
        'PackageType': {
            main: 'LABEL_PACKAGES',
            allSelected: 'LABEL_ALL_PACKAGES',
            tips: []
        }
    };

    export class ListMoverController implements IListMoverController {
        static $inject = [
            '$scope',
            '$q',
            '$translate',
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.common.SecurityService'
        ];

        // comes from directive's scope
        public centralOffice: boolean;
        public securityAccess: SecurityAccessEnum;
        public disabled: boolean;
        public template: string;
        public allSelectedSecurityKey: string;
        public allSelectedTemplate: string;
        public criteria: Object;
        public watchCriteria: boolean;
        public useAllItemsAsSelected: boolean;
        public defaultValue: Array<any>;
        public fetchOnStart: boolean;
        public fullResponse: boolean;
        public generic: boolean;
        public genericUrl: string;
        public genericArrayList: Array<any>;
        public identifier: string;
        public displayName: string;
        public postLoad: Function;
        public isSelectAllCheckboxHidden: boolean;
        public allSelected: boolean;
        public hideTopOnCollapse: boolean;
        public hideTitles: boolean;
        public topWidth: number;
        public advancedSearch: Object;
        public nullIfEmpty: boolean;
        public setIdOnCriteriaChanged: boolean;
        public required: boolean;
        public useSelectCaptions: boolean;
        public isSystemUserSelected?: boolean;
        public reportShortCut?: string;
        public watchDefaultValue?: boolean;
        public allSelectedToggleCallback?: (newValue: boolean) => void;

        // comes from directive's link function
        public ngModel: angular.INgModelController;

        // props used in templates
        public labels: ILabels = <ILabels>{};
        public fetching: boolean = false;
        public error: string = null;
        public securityDisabled: boolean = false;

        // lists used in template
        public available: IListMoverModel[] = [];
        public selected: IListMoverModel[] = [];
        public availableSelection: Array<string | number> = [];
        public selectedSelection: Array<string | number> = [];

        // private props
        private endPoint: string;
        private builtCriteria: Object = {};
        private canceller: ng.IDeferred<any> = null;
        private initModelValue = [];
        private all: IListMoverModel[] = [];
        private allWithoutSelected: IListMoverModel[] = [];

        private _initCriteriaStringValue: string;
        public  isAdding: boolean;

        get isCriteriaChanged(): boolean {
            return this._initCriteriaStringValue !== JSON.stringify(this.criteria || {});
        }

        get modelViewValue(): any[] {
            let value = this.ngModel.$viewValue;

            return value === null || !value ? [] : value;
        }

        get isValid(): boolean {
            if (!this.required) {
                return true;
            }

            return this.allSelected || this.selected.length > 0;
        }

        constructor(private $scope: angular.IScope,
                    private $q: angular.IQService,
                    private $translate: angular.translate.ITranslateService,
                    private appSettings: Meevo.Components.Common.IAppSettings,
                    private dataService: Meevo.Components.BaseClasses.IDataService,
                    private securityService: Meevo.Components.Common.ISecurityService) {
            this.labels.error = this.$translate.instant('LABEL_FETCHING_LIST_ERROR');
        }

        init(): void {
            if (this.centralOffice) {
            }

            this._initCriteriaStringValue = JSON.stringify(this.criteria || {});

            if (angular.isUndefined(this.setIdOnCriteriaChanged)) {
                this.setIdOnCriteriaChanged = false;
            }

            if (angular.isUndefined(this.useAllItemsAsSelected)) {
                this.useAllItemsAsSelected = false;
            }

            if (angular.isUndefined(this.required)) {
                this.required = false;
            }

            if (angular.isUndefined(this.nullIfEmpty)) {
                this.nullIfEmpty = false;
            }

            if (angular.isUndefined(this.hideTopOnCollapse)) {
                this.hideTopOnCollapse = false;
            }

            if (angular.isUndefined(this.fullResponse)) {
                this.fullResponse = false;
            }

            if (angular.isUndefined(this.fetchOnStart)) {
                this.fetchOnStart = true;
            }

            if (angular.isUndefined(this.identifier)) {
                this.identifier = 'id';
            }

            if (angular.isUndefined(this.displayName)) {
                this.displayName = 'displayName';
            }

            if (angular.isUndefined(this.hideTitles)) {
                this.hideTitles = false;
            }

            if (angular.isUndefined(this.advancedSearch)) {
                this.advancedSearch = {};
            }

            if (angular.isUndefined(this.isSystemUserSelected)) {
                this.isSystemUserSelected = false;
            }

            this.isSelectAllCheckboxHidden = angular.isUndefined(this.isSelectAllCheckboxHidden) ? false : this.isSelectAllCheckboxHidden;
            this.allSelected = angular.isUndefined(this.allSelected) ? true : this.allSelected;
            this.available = [];
            this.selected = [];
            this.availableSelection = [];
            this.selectedSelection = [];

            if (this.fullResponse && this.ngModel && Array.isArray(this.ngModel.$modelValue)) {
                this.selected = [...this.ngModel.$modelValue];
            }

            this.setWatchers();
            this.initProps();

            if (this.allSelectedSecurityKey) {
                this.securityService
                    .checkSecurityKey(this.allSelectedSecurityKey)
                    .then(res => this.allSelected = res === SecurityAccessEnum.Grant)
                    .catch(() => this.allSelected = false);
            }

            if (this.securityAccess !== SecurityAccessEnum.Grant) {
                this.securityDisabled = true;
                this.allSelected = false;
            }

            if (this.modelViewValue.length || (this.defaultValue && this.defaultValue.length) || !this.allSelected) {
                this.allSelected = false;
                if (this.defaultValue && this.defaultValue.length) {
                    this.resetModelViewValue(this.defaultValue);
                    this.populate(this.defaultValue);
                }
                if (!this.generic && !this.genericArrayList && this.fetchOnStart) {
                    this.fetchList();
                }
            } else if (this.useAllItemsAsSelected && !this.generic && !this.genericArrayList) {
                this.fetchList(true);
            } else {
                this.resetModelViewValue();
            }
        }

        /**
         * Initialize properties of mover based on attributes passed into directive
         * */
        initProps(): void {
            let criteria = {},
                labels = {};

            if (this.template.indexOf('report') === 0) {
                const cutTemplate = this.template.split('report')[1];

                this.endPoint = `${this.appSettings.API_ENDPOINTS.report}/${cutTemplate}`;

                labels = LABELS[cutTemplate];

                criteria = {
                    businessTypeList: null,
                    locationList: null,
                    hierarchyId: null,
                    branchId: null,
                    objectStateEnumList: [ObjectStateEnum.Active],
                    displayName: null,
                    fieldOrderBy: 'DisplayName',
                    orderAscDesc: 'Ascending'
                };

                if (cutTemplate === 'MenuItem') {
                    criteria = {};
                } else if (cutTemplate === 'User') {
                    criteria = {
                        showEmployeesOnly: false,
                        includeActive: true,
                        includeInactive: false,
                        includeDeleted: false,
                        showTerminated: false,
                        firstName: '',
                        lastName: '',
                        coFilterByLocationId: null,
                        coBusinessTypeId: null,
                        filter: ''
                    };
                }
            } else {
                if (this.generic) {
                    this.endPoint = this.genericUrl;
                    labels['main'] = this.template;
                    labels['allSelected'] = this.allSelectedTemplate;
                    if (this.genericArrayList && this.genericArrayList.length) {
                        this.populate(this.genericArrayList);
                    }
                } else {
                    let apiEndpointKey = this.template.slice(0, 1).toLowerCase() + this.template.slice(1);
                    this.endPoint = this.appSettings.API_ENDPOINTS[this.template] || this.appSettings.API_ENDPOINTS[apiEndpointKey];
                    labels = LABELS[this.template];
                }
            }

            if (typeof labels === 'undefined') {
                throw new Error('Please add proper template option to switch into ListMoverController');
            }

            if (angular.isObject(this.criteria)) {
                angular.extend(this.builtCriteria, criteria, this.criteria);
            } else {
                angular.extend(this.builtCriteria, criteria);
            }

            angular.extend(this.labels, labels);
        }

        /**
         * Fetch items list
         * */
        fetchList(selectAllItems: boolean = false): void {
            if (this.canceller) {
                this.canceller.resolve();
            }

            this.canceller = this.$q.defer();
            this.fetching = true;

            if (angular.isObject(this.criteria)) {
                angular.extend(this.builtCriteria, this.criteria);
            }

            this.dataService.getListPaged(this.endPoint, angular.extend({
                criteria: this.builtCriteria,
                itemsPerPage: 50000 // todo: dev
            }, this.advancedSearch), null, null, {
                timeout: this.canceller.promise
            })
                .then((list: IListMoverModel[]) => {
                    if (angular.isFunction(this.postLoad)) {
                        this.postLoad({list});
                    }

                    if (selectAllItems) {
                        this.resetModelViewValue(this.fullResponse ? list : list.map(c => c[this.identifier]));
                    } else {
                        this.populate(list);
                    }

                    if (this.defaultValue && this.defaultValue.length > 0) {
                        this.defaultValue.forEach((item) => {
                            let element = _.find(this.available, c => c[this.identifier] == item[this.identifier])
                            if (element) {
                                element.selected = true
                            }
                        });
                        this.updateLists();
                    }
                    this.error = null;
                })
                .catch(() => {
                    this.error = 'Could not fetch requested list. Mover control can not be initialized.';
                })
                .finally(() => {
                    this.fetching = false;
                });
        }

        /**
         * Process list of items
         * @param {IListMoverModel[]} list
         * */
        populate(list: IListMoverModel[]): void {
            if (list === null) {
                return;
            }

            this.allWithoutSelected = angular.copy(list);

            // merge new list of items with selected items
            if (this.selected.length && !this.allSelected) {
                list = _.uniq(list.concat(this.selected), false, i => i[this.identifier]);
            }

            this.all = list
                .map((item): IListMoverModel => {
                    let selected = false;

                    if (this.securityAccess === SecurityAccessEnum.Grant) {
                        if (this.modelViewValue.length > 0) {
                            selected = this.modelViewValue.some(mItem => {
                                return item[this.identifier] === (this.fullResponse ? mItem[this.identifier] : mItem)
                            });
                        }
                    } else {
                        selected = true;
                    }

                    let cutTemplate = this.template.split('report')[1];

                    if (cutTemplate === 'User') {
                        return {
                            [this.displayName]: item[this.displayName].replace(/,|: /gi, ''),
                            selected,
                            [this.identifier]: item[this.identifier]
                        }
                    } else if (this.fullResponse) {
                        return {
                            ...item,
                            selected
                        }
                    } else {
                        return <IListMoverModel> {
                            [this.displayName]: item[this.displayName],
                            selected,
                            [this.identifier]: item[this.identifier]
                        };
                    }
                });

            this.updateLists();
        }

        /**
         * Set watchers
         * */
        setWatchers(): void {
            if (this.required) {
                this.$scope.$watch(() => this.isValid, (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        this.ngModel.$setValidity('mover-required', newValue);
                    }
                })
            }

            if (this.watchCriteria) {
                this.$scope.$watch(() => this.criteria, (newValue, oldValue) => {
                    if (newValue === oldValue || !newValue) return;

                    this.fetchList(this.allSelected);
                }, true);
            }
            if (this.generic) {
                this.$scope.$watch(() => this.genericArrayList, (newValue, oldValue) => {
                    if (newValue === oldValue || !newValue) return;

                    if(newValue.length === 0) {
                        this.selected = [];
                    }

                    if (this.defaultValue && this.defaultValue.length > 0) {
                        this.resetModelViewValue(this.defaultValue);
                    }

                    this.populate(newValue);
                }, true);
            }

            this.$scope.$watch(() => this.advancedSearch, (newValue, oldValue) => {
                if (newValue === oldValue || !newValue || Object.keys(newValue).length === 0) return;

                this.fetchList();
            }, true);

            this.$scope.$watch(() => this.isSystemUserSelected, (newValue: boolean, oldValue: boolean) => {
                if (newValue === oldValue) return;

                this.allSelected = !newValue;
                if (newValue) {
                    this.setModelValueWithSystemUser();
                } else {
                    this.fetchList(true);
                }
            });

            if (this.reportShortCut && this.reportShortCut === 'MR080') {
                this.$scope.$on('openCloseHistoryModelValueSet', () => {
                    this.allSelected = false;
                    this.fetchList();
                });
            }
        }

        /**
         * Update model with System User
         */
        setModelValueWithSystemUser() {
            this.ngModel.$setViewValue([{
                id: '00000000-0000-0000-0000-000000000001',
                user_TId: '00000000-0000-0000-0000-000000000001',
                displayName: this.$translate.instant('LABEL_TRIGGERED_BY_ACCOUNT_SYNC'),
            }]);
        }

        /**
         * Update selected and available lists
         * */
        updateLists(): void {
            let value;

            this.selected =  this.getList(true);
            this.available = this.getList(false);

            this.availableSelection = [];
            this.selectedSelection = [];

            value = this.all
                .filter((c: IListMoverModel) => c.selected);

            if (!this.fullResponse) {
                value = value.map((c: IListMoverModel) => c[this.identifier]);
            }

            this.resetModelViewValue(value);
        }

        /**
         * Select item
         * */
        select(): void {
            this.available.forEach((c: IListMoverModel) => {
                if (this.availableSelection.indexOf(c[this.identifier]) > -1) c.selected = true;
            });
            this.updateLists();
        }

        /**
         * Deselect item
         * */
        deselect(): void {
            this.selected.forEach((c: IListMoverModel) => {
                if (this.selectedSelection.indexOf(c[this.identifier]) > -1) c.selected = false;
            });
            this.updateLists();
        }

        /**
         * Move all items
         * @param {boolean} selected
         * */
        moveAll(selected: boolean): void {
            this.all.forEach((c: IListMoverModel) => {
                c.selected = selected;
            });
            this.updateLists();
        }

        /**
         * Get selected or deselected list by boolean criteria
         * @param {boolean} selected
         * */
        getList(selected: boolean): IListMoverModel[] {
            return this.all.filter((c: IListMoverModel) => c.selected === selected);
        }

        /**
         * Callback for check/uncheck all items
         * */
        checkAllCallback(): void {
            if (this.allSelected) {
                if (this.useAllItemsAsSelected) {
                    this.resetModelViewValue(this.fullResponse ? this.allWithoutSelected : this.allWithoutSelected.map((c: IListMoverModel) => c[this.identifier]));
                    this.selected = [];
                } else {
                    this.all = [];
                    this.updateLists();
                }
            } else {
                if (this.useAllItemsAsSelected) {
                    this.resetModelViewValue(this.defaultValue);
                }
                if (!this.generic && !this.genericArrayList) {
                    this.fetchList();
                } else {
                    this.populate(this.genericArrayList);
                }
            }
            if (typeof this.allSelectedToggleCallback === 'function') {
                this.allSelectedToggleCallback(this.allSelected);
            }
        }

        /**
         * Reset model view value
         * @param {string[]} newValue
         * */
        resetModelViewValue(newValue: any[] = null) {

            if (this.nullIfEmpty && Array.isArray(newValue) && newValue.length === 0) {
                newValue = null;
            } else if (
                !this.setIdOnCriteriaChanged &&
                Array.isArray(newValue) && (newValue.length === 0 || newValue.length === this.all.length) ||
                newValue === null
            ) {
                newValue = this.useAllItemsAsSelected ? newValue : this.initModelValue;
            }

            if (this.isSystemUserSelected) {
                this.setModelValueWithSystemUser();
            } else {
                this.ngModel.$setViewValue(newValue);
            }
        }
    }
}
